const STORAGE_KEY = 'iti_chiffrage_site_draft';
const DRAFT_VERSION = 1;

export function loadChiffrageSiteDraft() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || parsed.version !== DRAFT_VERSION) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function saveChiffrageSiteDraft(draft) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      version: DRAFT_VERSION,
      savedAt: new Date().toISOString(),
      ...draft,
    }));
  } catch {
    // quota dépassé ou navigation privée
  }
}

export function clearChiffrageSiteDraft() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

const CREDIT_TEMPS_REFS = ['TME00', 'TME01', 'TME02', 'TME03', 'DEV001'];
const LEGACY_CREDIT_TEMPS_REFS = ['TME04'];
const LEGACY_MAINTENANCE_REFS = ['TME05', 'TME06', 'TME07', 'TME08'];

export function mergeWipWithDefaults(defaultWip, savedWip) {
  if (!savedWip || typeof savedWip !== 'object') {
    return {
      ...(defaultWip ?? {}),
      FormationAdministration: true,
      NddPrincipal: true,
      ContratDeMiseAJour: 'Aucun',
    };
  }
  const merged = { ...(defaultWip ?? {}), ...savedWip };

  if (merged.NddSecondaire && !merged.NbNddSecondaire) {
    merged.NbNddSecondaire = 1;
  }
  delete merged.NddSecondaire;

  // Anciens brouillons : crédit temps parfois stocké dans ContratDeMiseAJour
  if (CREDIT_TEMPS_REFS.includes(merged.ContratDeMiseAJour)) {
    if (!merged.CreditTemps || merged.CreditTemps === 'Aucun') {
      merged.CreditTemps = merged.ContratDeMiseAJour;
    }
    merged.ContratDeMiseAJour = 'Aucun';
  }

  if (LEGACY_CREDIT_TEMPS_REFS.includes(merged.CreditTemps) || LEGACY_MAINTENANCE_REFS.includes(merged.CreditTemps)) {
    merged.CreditTemps = 'Aucun';
  }

  if (LEGACY_MAINTENANCE_REFS.includes(merged.ContratDeMiseAJour) || LEGACY_CREDIT_TEMPS_REFS.includes(merged.ContratDeMiseAJour)) {
    merged.ContratDeMiseAJour = 'Aucun';
  }

  if (!merged.Hebergement) {
    merged.Hebergement = 'Aucun';
  }

  return merged;
}

/**
 * Restaure le commercial du brouillon.
 * - undefined : pas encore de brouillon → premier commercial
 * - '' / null : vidé volontairement → rester vide
 * - id connu : le garder
 * - id inconnu : rester vide (ne pas forcer un autre)
 */
export function resolveCommercialId(savedId, commerciaux) {
  const list = commerciaux ?? [];

  if (savedId === undefined) {
    return list[0]?.id != null ? String(list[0].id) : '';
  }

  if (savedId === null || String(savedId).trim() === '') {
    return '';
  }

  const id = String(savedId);
  if (list.some((c) => String(c.id) === id)) {
    return id;
  }

  return '';
}

export function clampWizardStep(step) {
  const n = Number(step);
  if (!Number.isFinite(n)) return 0;
  return Math.min(2, Math.max(0, Math.floor(n)));
}
